import { useEffect, useRef, useState } from "react"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import * as driverApis from "../../utilities/apis/driver"
import Layout from "../../components/Layout"

const Driver = () => {
  const navigate = useNavigate()
  const { token } = useSelector(state => state.user)
  const nameRef = useRef(null)
  const mobileRef = useRef(null)
  const usernameRef = useRef(null)
  const passwordRef = useRef(null)
  const commissionRef = useRef(null)
  const params = new URLSearchParams(window.location.search)
  const [active, setActive] = useState(true)

  const handleSubmit = async (e) => {
    try {
      e.preventDefault()

      const name = e.target.name.value
      const mobile = e.target.mobile.value
      const username = e.target.username.value
      const password = e.target.password.value
      const commission = e.target.commission.value
      const payload = { active, name, mobile, username, password, commission }

      if (!params.has("id")) {
        const response = await driverApis.createDriver(token, payload)
        if (!response.status) throw new Error(response.message)

        // e.target.reset()
      } else {
        payload.id = parseInt(params.get("id"))
        const response = await driverApis.updateDriver(token, payload)
        if (!response.status) throw new Error(response.message)
      }

      alert("Rider saved")
    } catch (error) {
      alert(error.message)
    }
  }

  const getDriver = async () => {
    try {
      const response = await driverApis.getDriver(token, params.get("id"))
      if (!response.status) throw new Error(response.message)

      setActive(response.driver.active)
      nameRef.current.value = response.driver.name
      mobileRef.current.value = response.driver.mobile
      usernameRef.current.value = response.driver.username
      passwordRef.current.value = response.driver.password
      commissionRef.current.value = response.driver.commission
    } catch (error) {
      alert(error.message)
    }
  }

  useEffect(() => {
    if (params.has("id")) getDriver()
  }, [])

  return (
    <Layout
      header={true}
      footer={true}
    >
      <main className="py-3">
        <div className="container">
          <form method="POST" onSubmit={handleSubmit}>
            <div className="d-flex flex-column gap-3">
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex gap-3 align-items-center">
                  <button type="button" className="btn btn-secondary rounded-4" onClick={() => navigate(-1)}><i className="bi bi-chevron-left"></i></button>
                  <p className="lead text-body-emphasis fw-bold m-0">{params.has("id") ? "Edit" : "Add"} Rider</p>
                </div>
                <button type="submit" className="btn btn-theme rounded-4">Save</button>
              </div>

              <div className="row">
                <div className="col-md-8">
                  <div className="card rounded-4 shadow-none">
                    <div className="card-body py-4">
                      <div className="d-flex flex-column gap-3">
                        <div className="form-check">
                          <input className="form-check-input" type="checkbox" id="active" checked={active} onChange={() => setActive(!active)} />
                          <label className="form-check-label" htmlFor="active">Active</label>
                        </div>
                        <div>
                          <label htmlFor="name" className="form-label">Name</label>
                          <input ref={nameRef} type="text" name="name" className="form-control" id="name" placeholder="Name" required />
                        </div>
                        <div>
                          <label htmlFor="mobile" className="form-label">Mobile #</label>
                          <input ref={mobileRef} type="tel" name="mobile" className="form-control" id="mobile" placeholder="Mobile #" required />
                        </div>
                        <div>
                          <label htmlFor="username" className="form-label">Username</label>
                          <input ref={usernameRef} type="text" name="username" className="form-control" id="username" placeholder="Username" required />
                        </div>
                        <div>
                          <label htmlFor="password" className="form-label">Password</label>
                          <input ref={passwordRef} type="password" name="password" className="form-control" id="password" placeholder="Password" required />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card rounded-4 shadow-none">
                    <div className="card-body py-4">
                      <div className="d-flex flex-column gap-3">
                        <div>
                          <label htmlFor="commission" className="form-label">Commission</label>
                          <input ref={commissionRef} type="number" name="commission" className="form-control" id="commission" step="0.01" required />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </main>
    </Layout>
  )
}

export default Driver
